"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKeyboardChoices = void 0;
exports.addKeyboardListeners = addKeyboardListeners;
const __1 = require("../../..");
const taskSetup_1 = require("../../taskSetup");
const audioHandler_1 = require("./audioHandler");
const taskStore_1 = require("../../../taskStore");
const getKeyboardChoices_1 = require("./getKeyboardChoices");
Object.defineProperty(exports, "getKeyboardChoices", { enumerable: true, get: function () { return getKeyboardChoices_1.getKeyboardChoices; } });
function enableBtns(btnElements) {
    btnElements.forEach((btn) => (btn.disabled = false));
}
function addKeyboardListeners(stim, isTouchScreen, itemConfig) {
    const practiceBtns = document.querySelectorAll('.practice-btn');
    let keyboardFeedbackHandler;
    practiceBtns.forEach((btn, i) => btn.addEventListener('click', async (e) => {
        handleKeyboardPracticeBtn(btn, stim, practiceBtns, false, i, itemConfig);
    }));
    if (!isTouchScreen) {
        keyboardFeedbackHandler = (e) => keyboardBtnFeedback(e, practiceBtns, stim, itemConfig);
        document.addEventListener('keydown', keyboardFeedbackHandler);
        return keyboardFeedbackHandler;
    }
}
async function keyboardBtnFeedback(e, practiceBtns, stim, itemConfig) {
    const allowedKeys = (0, getKeyboardChoices_1.getKeyboardChoices)(itemConfig);
    const index = allowedKeys.findIndex((f) => f === e.key);
    if (allowedKeys.includes(e.key)) {
        const btnClicked = practiceBtns[index];
        if (btnClicked) {
            handleKeyboardPracticeBtn(btnClicked, stim, practiceBtns, true, e.key.toLowerCase(), itemConfig);
        }
    }
}
function handleKeyboardPracticeBtn(btn, stim, practiceBtns, isKeyBoardResponse, responseValue, itemConfig) {
    var _a, _b;
    const index = Array.prototype.indexOf.call(practiceBtns, btn);
    const choices = ((_a = itemConfig.response) === null || _a === void 0 ? void 0 : _a.values) || [];
    const choice = choices[index];
    const isCorrectChoice = (choice === null || choice === void 0 ? void 0 : choice.toString()) === ((_b = stim.answer) === null || _b === void 0 ? void 0 : _b.toString());
    let feedbackAudio;
    if (isCorrectChoice) {
        btn.classList.add('success-shadow');
        feedbackAudio = __1.mediaAssets.audio.feedbackGoodJob;
        setTimeout(() => taskSetup_1.jsPsych.finishTrial({
            response: choice,
            incorrectPracticeResponses: (0, taskStore_1.taskStore)().incorrectPracticeResponses,
            button_response: !isKeyBoardResponse ? responseValue : null,
            keyboard_response: isKeyBoardResponse ? responseValue : null,
        }), 1000);
    }
    else {
        btn.classList.add('error-shadow');
        feedbackAudio = __1.mediaAssets.audio.feedbackTryAgain;
        // jspysch disables the buttons for some reason, so re-enable them
        setTimeout(() => enableBtns(practiceBtns), 500);
        let incorrectPracticeResponses = (0, taskStore_1.taskStore)().incorrectPracticeResponses;
        incorrectPracticeResponses.push(choice);
        (0, taskStore_1.taskStore)('incorrectPracticeResponses', incorrectPracticeResponses);
    }
    // if there is audio playing, stop it first before playing feedback audio to prevent overlap between trials
    audioHandler_1.PageAudioHandler.stopAndDisconnectNode();
    audioHandler_1.PageAudioHandler.playAudio(feedbackAudio);
}
